import { render, staticRenderFns } from "./AddUpdateCourse.vue?vue&type=template&id=ef89b742&"
import script from "./AddUpdateCourse.vue?vue&type=script&lang=js&"
export * from "./AddUpdateCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports